export*from"lit-html/static.js";
